import { TextField, useMediaQuery, useTheme } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { CONTROLE_ALTURA, CONTROLE_ALTURA_MOBILE, CONTROLE_RADIUS } from './listagemCellStyles';

interface IListagemBuscaFieldProps {
  value: string;
  onChange: (valor: string) => void;
  placeholder: string;
  inputRef?: React.Ref<HTMLInputElement>;
  // Handler de teclado pronto pra uso — normalmente `onBuscaKeyDown` de
  // `useListagemKeyboardNav` (seta-baixo manda o foco pra primeira linha da listagem).
  onKeyDown?: (event: React.KeyboardEvent) => void;
}

export const ListagemBuscaField: React.FC<IListagemBuscaFieldProps> = ({
  value,
  onChange,
  placeholder,
  inputRef,
  onKeyDown,
}) => {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <TextField
      size='small'
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      inputRef={inputRef}
      sx={{
        flex: 1,
        minWidth: smDown ? 0 : 240,
        width: smDown ? '100%' : undefined,
        '& .MuiOutlinedInput-root': {
          height: `${smDown ? CONTROLE_ALTURA_MOBILE : CONTROLE_ALTURA}px`,
          borderRadius: CONTROLE_RADIUS,
          backgroundColor: theme.torq.surface.card,
        },
      }}
      InputProps={{
        startAdornment: <SearchRoundedIcon fontSize='small' sx={{ mr: 1, color: theme.torq.text.muted }} />,
      }}
    />
  );
};
